<template>
  <QuickLinks :quickLinks="quickLinks" />
</template>

<script>
import QuickLinks from "../../components/QuickLinks/QuickLinks.vue";

export default {
  name: "app",
  components: {
    QuickLinks
  },
  data() {
    return {
      quickLinks: JSON.parse(this.$options._parentVnode.data.props.quickLinks),
    };
  }
};
</script>
